var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalesBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 526.55 227.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5,.cls-6,.cls-7,.cls-8{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{opacity:0.31;}.cls-5,.cls-6,.cls-7,.cls-8{stroke:#009cdf;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.88px;}.cls-6{stroke-dasharray:4.4 4.4;}.cls-7{stroke-dasharray:4.36 4.36;}.cls-8{stroke-dasharray:4.42 4.42;}.cls-9{fill:url(#linear-gradient);}.cls-10{fill:#0e0092;opacity:0.18;}.cls-10,.cls-28,.cls-31,.cls-34,.cls-36,.cls-38,.cls-43,.cls-46,.cls-48,.cls-53{mix-blend-mode:multiply;}.cls-11{fill:url(#linear-gradient-2);}.cls-12{fill:#def2fb;}.cls-13{fill:#fff;}.cls-14{fill:url(#linear-gradient-3);}.cls-15{fill:#43ffd9;}.cls-16{fill:#ff6570;}.cls-17,.cls-19,.cls-20,.cls-21{fill:#00d1ff;}.cls-18{fill:#ffe000;}.cls-19{opacity:0.75;}.cls-20,.cls-53{opacity:0.22;}.cls-21{opacity:0.48;}.cls-22{fill:#ffd2d2;}.cls-23{fill:#ffdede;}.cls-24{fill:#fccaca;}.cls-25{fill:#f8b024;}.cls-26{fill:url(#linear-gradient-4);}.cls-27,.cls-30{opacity:0.44;}.cls-27,.cls-30,.cls-33,.cls-42{mix-blend-mode:screen;}.cls-27{fill:url(#linear-gradient-5);}.cls-28,.cls-31{opacity:0.42;}.cls-28{fill:url(#linear-gradient-6);}.cls-29{fill:url(#linear-gradient-7);}.cls-30{fill:url(#linear-gradient-8);}.cls-31{fill:url(#linear-gradient-9);}.cls-32{fill:url(#linear-gradient-10);}.cls-33{fill:url(#linear-gradient-11);}.cls-34,.cls-36{opacity:0.3;}.cls-34{fill:url(#linear-gradient-12);}.cls-35{fill:url(#linear-gradient-13);}.cls-36{fill:url(#linear-gradient-14);}.cls-37{fill:url(#linear-gradient-15);}.cls-38,.cls-43{opacity:0.5;}.cls-39{fill:url(#linear-gradient-16);}.cls-40{fill:url(#linear-gradient-17);}.cls-41{fill:url(#linear-gradient-18);}.cls-42{fill:url(#linear-gradient-19);}.cls-43{fill:url(#linear-gradient-20);}.cls-44{fill:url(#linear-gradient-21);}.cls-45{fill:url(#linear-gradient-22);}.cls-46{opacity:0.8;fill:url(#linear-gradient-23);}.cls-47{fill:url(#linear-gradient-24);}.cls-48{fill:#e6f4ff;}.cls-49{fill:url(#linear-gradient-25);}.cls-50{fill:#0bf;}.cls-51{fill:#7fd4ff;}.cls-52,.cls-53{fill:#fc0;}.cls-54{fill:#ffda00;}.cls-55{fill:#ffe356;}.cls-56{fill:#3052e9;}.cls-57{fill:#030478;}.cls-58{fill:url(#linear-gradient-26);}.cls-59{fill:#f8c3c7;}.cls-60{fill:#fcc;}.cls-61{fill:#241d9e;}.cls-62{fill:url(#linear-gradient-27);}.cls-63{fill:url(#linear-gradient-28);}.cls-64{fill:#ff9a25;}.cls-65{fill:url(#linear-gradient-29);}.cls-66,.cls-69{opacity:0.55;}.cls-67,.cls-68,.cls-69{fill:#c2eeff;}.cls-67{opacity:0.69;}.cls-70{fill:url(#linear-gradient-30);}.cls-71{fill:url(#linear-gradient-31);}.cls-72{fill:url(#linear-gradient-32);}.cls-73{fill:url(#linear-gradient-33);}.cls-74{fill:url(#linear-gradient-34);}.cls-75{fill:url(#linear-gradient-35);}.cls-76{fill:#fdb42c;}.cls-77{fill:url(#linear-gradient-36);}.cls-78{fill:url(#linear-gradient-37);}.cls-79{fill:#bfe8f7;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-105.53 -147.61)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.68,
    y: 59.38,
    width: 628.65,
    height: 381.25,
    rx: 10.66
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 254.65,
    y1: 229.53,
    x2: 254.65,
    y2: 197.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#085eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e0092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 254.65,
    y1: 30.01,
    x2: 254.65,
    y2: 247.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28e8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0129ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 254.65,
    y1: 194.54,
    x2: 254.65,
    y2: 238.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 343.49,
    y1: 259.94,
    x2: 358.82,
    y2: 251.54,
    gradientTransform: "translate(168.91 -138.6) rotate(29.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0162ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 336.59,
    y1: 264.16,
    x2: 354.85,
    y2: 253.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 354.83,
    y1: 256.71,
    x2: 339.41,
    y2: 266.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 349.67,
    y1: 256.62,
    x2: 365.66,
    y2: 247.64,
    gradientTransform: "translate(167.42 -144.36) rotate(29.13)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 347,
    y1: 256.48,
    x2: 367.31,
    y2: 245.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 367,
    y1: 249.25,
    x2: 348.59,
    y2: 260.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 357.69,
    y1: 254.34,
    x2: 394.75,
    y2: 231.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ff9a25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 353.84,
    y1: 246.41,
    x2: 387.28,
    y2: 218.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 353.23,
    y1: 258.97,
    x2: 400.79,
    y2: 244.87,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 383.82,
    y1: 237.39,
    x2: 417,
    y2: 219.14,
    gradientTransform: "translate(161.22 -168.19) rotate(29.13)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 386.17,
    y1: 227.85,
    x2: 418.08,
    y2: 227.85,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 394.71,
    y1: 211.13,
    x2: 430.21,
    y2: 270.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 387.21,
    y1: 223.13,
    x2: 423.14,
    y2: 223.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 382.36,
    y1: 228.1,
    x2: 424.66,
    y2: 228.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 401.9,
    y1: 227.22,
    x2: 391.67,
    y2: 234.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 402.1,
    y1: 217.46,
    x2: 389.71,
    y2: 225.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 416.97,
    y1: 228.16,
    x2: 397.18,
    y2: 238.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 402.14,
    y1: 221.4,
    x2: 415.41,
    y2: 246.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 254.97,
    y1: 167.94,
    x2: 254.97,
    y2: 216.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 363.43,
    y1: 342.9,
    x2: 363.43,
    y2: 302.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 382.24,
    y1: 234.12,
    x2: 457.15,
    y2: 197.42,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 118.71,
    y1: 146.83,
    x2: 118.71,
    y2: 218.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec374f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 551.85,
    y1: 289.68,
    x2: 502.52,
    y2: 244.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 547.7,
    y1: 262.37,
    x2: 491.68,
    y2: 262.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 499.34,
    y1: 267.56,
    x2: 499.34,
    y2: 220.27,
    gradientTransform: "translate(21.29 -43.96) rotate(4.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00a373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43ffd9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 381.77,
    y1: 256.6,
    x2: 381.77,
    y2: 121.22,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 249.05,
    y1: 293.76,
    x2: 249.05,
    y2: 264.45,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 239.16,
    y1: 313.34,
    x2: 239.16,
    y2: 381.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 251.63,
    y1: 326.01,
    x2: 251.63,
    y2: 286.89,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 434.41,
    y1: 285.88,
    x2: 424.39,
    y2: 316.59,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 432.29,
    y1: 300.13,
    x2: 432.29,
    y2: 352.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 428.26,
    y1: 308.52,
    x2: 428.26,
    y2: 367.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 396.87,
    y1: 286.54,
    x2: 431.55,
    y2: 288.92,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 422.5,
    y1: 282.05,
    x2: 422.5,
    y2: 322.1,
    xlinkHref: "#linear-gradient-25"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M265.75,357.45l-2.2.12",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.16,357.8C136,364.25,100.4,351.52,106.65,311c13.19-85.63,296.44-28.73,416.88-25.56,101.36,2.66,131.18-132.52-43.61-120.55-14.62,1-44.41,18.18-44,58.81",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M436,225.9c0,.73.06,1.46.11,2.2",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M414.77,219.67a16.21,16.21,0,0,0,1.25-1.8",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M417.94,214c3.25-8,4.73-20,3.83-27.67-1.16-9.86-6.16-18.68-12.8-22.58-8.77-5.15-18.76-1.75-28.17.39-25.14,5.74-50.89,1.83-76.07-3.56s-50.34-12.28-75.83-12.49-51.74,6.8-72.7,26.89c-6.75,6.47-13,14.56-16.26,25s-2.77,23.67,2.76,32.07c6.35,9.65,16.94,10.44,26.36,10.54l76.23.88",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M247.48,243.48l2.2,0",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M364.57,352.19h2.2",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M371.19,352.21q109.23.38,218.45-.54c9-.08,18.26-.21,26.55-3.41s15.44-10.28,15.44-18.5c0-11.12-12.21-18.81-23.68-22.52-22.18-7.18-46.23-7.3-69.75-7.34l-152.31-.28",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.68,299.62h-2.2",
    transform: "translate(-105.53 -147.61)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 230.93,
    y: 198.41,
    width: 47.44,
    height: 18.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 230.93,
    y: 198.41,
    width: 47.44,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 128.23,
    y: 58.89,
    width: 252.85,
    height: 143.15,
    rx: 8.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 134.9,
    y: 65.38,
    width: 239.5,
    height: 130.16,
    rx: 5.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 134.9,
    y: 73.78,
    width: 239.5,
    height: 113.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 183.66,
    y: 216.74,
    width: 141.98,
    height: 5.33,
    rx: 2.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M250.45,267.17a20.59,20.59,0,1,0-1.4-7.46A20.32,20.32,0,0,0,250.45,267.17Zm8.74-13.52A12.1,12.1,0,1,1,270,271.8h-.31a12.11,12.11,0,0,1-10.48-18.16Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M269.67,280.32v-8.51H270a12.09,12.09,0,0,0,7.84-21l5.67-6.35a20.61,20.61,0,0,1-13.82,35.9Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M249.05,259.71a20.52,20.52,0,0,1,2.83-10.43l7.32,4.37a12.11,12.11,0,0,0-.79,10.5l-8,3A20.32,20.32,0,0,1,249.05,259.71Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M251.88,249.28a20.61,20.61,0,0,1,31.61-4.86l-5.67,6.35a12.08,12.08,0,0,0-18.62,2.88Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M308.37,240.48a20.7,20.7,0,1,0,7.46-1.39A20.65,20.65,0,0,0,308.37,240.48Zm13.52,8.75A12.1,12.1,0,1,1,303.74,260c0-.1,0-.21,0-.31a12.09,12.09,0,0,1,7.66-11.26,12.06,12.06,0,0,1,10.5.78Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M295.22,259.71h8.51c0,.1,0,.21,0,.31a12.09,12.09,0,0,0,21,7.84l6.36,5.67a20.62,20.62,0,0,1-35.91-13.82Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M315.84,239.09a20.57,20.57,0,0,1,10.42,2.82l-4.37,7.32a12.06,12.06,0,0,0-10.5-.78l-3-8A20.57,20.57,0,0,1,315.84,239.09Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M326.26,241.91a20.63,20.63,0,0,1,4.87,31.62l-6.35-5.67a12.1,12.1,0,0,0-2.89-18.63Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M328.64,292.84H256.13a2.48,2.48,0,0,1-2.48-2.48V290a2.48,2.48,0,0,1,2.48-2.48h72.51a2.48,2.48,0,0,1,2.48,2.48v.41A2.48,2.48,0,0,1,328.64,292.84Zm0,3.81H256.13a2.48,2.48,0,0,0-2.48,2.47v.41a2.48,2.48,0,0,0,2.48,2.48h72.51a2.48,2.48,0,0,0,2.48-2.48v-.41A2.48,2.48,0,0,0,328.64,296.65Zm0,9.17H256.13a2.48,2.48,0,0,0-2.48,2.48v.4a2.48,2.48,0,0,0,2.48,2.48h72.51a2.48,2.48,0,0,0,2.48-2.48v-.4A2.48,2.48,0,0,0,328.64,305.82Zm0,9.17H256.13a2.48,2.48,0,0,0-2.48,2.48v.41a2.48,2.48,0,0,0,2.48,2.47h72.51a2.48,2.48,0,0,0,2.48-2.47v-.41A2.48,2.48,0,0,0,328.64,315Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 282.38,
    y: 100.94,
    width: 82.51,
    height: 79.48,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M419.27,284H398.21a4.09,4.09,0,0,1-4.1-4.1V258.85a4.1,4.1,0,0,1,4.1-4.11h21.06a4.11,4.11,0,0,1,4.11,4.11v21.06A4.1,4.1,0,0,1,419.27,284Zm44.93-26.12v-.2a1.25,1.25,0,0,0-1.24-1.24H428.74a1.25,1.25,0,0,0-1.24,1.24v.2a1.24,1.24,0,0,0,1.24,1.24H463A1.24,1.24,0,0,0,464.2,257.89Zm0,7.52v.21a1.25,1.25,0,0,1-1.24,1.24H428.74a1.25,1.25,0,0,1-1.24-1.24v-.21a1.25,1.25,0,0,1,1.24-1.24H463A1.25,1.25,0,0,1,464.2,265.41Zm0,7.73v.2a1.24,1.24,0,0,1-1.24,1.24H428.74a1.24,1.24,0,0,1-1.24-1.24v-.2a1.24,1.24,0,0,1,1.24-1.24H463A1.24,1.24,0,0,1,464.2,273.14Zm0,7.72v.21a1.25,1.25,0,0,1-1.24,1.24H428.74a1.25,1.25,0,0,1-1.24-1.24v-.21a1.25,1.25,0,0,1,1.24-1.24H463A1.25,1.25,0,0,1,464.2,280.86Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M419.27,321.72H398.21a4.09,4.09,0,0,1-4.1-4.1V296.55a4.1,4.1,0,0,1,4.1-4.1h21.06a4.11,4.11,0,0,1,4.11,4.1v21.07A4.1,4.1,0,0,1,419.27,321.72ZM464.2,295.6v-.2a1.24,1.24,0,0,0-1.24-1.24H428.74a1.24,1.24,0,0,0-1.24,1.24v.2a1.24,1.24,0,0,0,1.24,1.24H463A1.24,1.24,0,0,0,464.2,295.6Zm0,7.52v.21a1.25,1.25,0,0,1-1.24,1.24H428.74a1.25,1.25,0,0,1-1.24-1.24v-.21a1.25,1.25,0,0,1,1.24-1.24H463A1.25,1.25,0,0,1,464.2,303.12Zm0,7.73v.2a1.24,1.24,0,0,1-1.24,1.24H428.74a1.24,1.24,0,0,1-1.24-1.24v-.2a1.24,1.24,0,0,1,1.24-1.24H463A1.24,1.24,0,0,1,464.2,310.85Zm0,7.72v.21A1.25,1.25,0,0,1,463,320H428.74a1.25,1.25,0,0,1-1.24-1.24v-.21a1.25,1.25,0,0,1,1.24-1.24H463A1.25,1.25,0,0,1,464.2,318.57Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M351.33,305.08c6.47,2.79,14.71,2.92,20.16,1.85l-1.34-7.52-17.83-15.86Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M355.11,306.37a26.7,26.7,0,0,1-3.78-1.29l1-21.53,3.74,3.33A186.46,186.46,0,0,0,355.11,306.37Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M361,307.38a38,38,0,0,0,10.54-.45l-1.34-7.52-10.92-6.06A135.34,135.34,0,0,0,361,307.38Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M364,268c5.66-2.05,10.15-.72,14.5,6.73S388.84,288.68,386,291s-8.48,9-17,8.39C356.27,298.4,347.43,274,364,268Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M379.54,293.77h0a5.8,5.8,0,0,1-7.89-2.24l-18.22-32.69,14.48-8.06,14.2,35.78A5.8,5.8,0,0,1,379.54,293.77Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 341.08,
    y: 246.9,
    width: 20.19,
    height: 17.65,
    rx: 8.16,
    transform: "translate(-185.6 55.69) rotate(-29.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M345.84,254.55l6.27-3.5a6.51,6.51,0,0,1,8.85,2.52l2,3.54a6.51,6.51,0,0,0-.78-2.44l-2.26-4.06a6.51,6.51,0,0,0-8.85-2.51l-6.27,3.49a6.51,6.51,0,0,0-2.52,8.85l.29.51A6.49,6.49,0,0,1,345.84,254.55Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M361.12,252.84l-2.26-4.05a6.41,6.41,0,0,0-1.05-1.4l1.18,2.13a6.5,6.5,0,0,1-2.51,8.85l-6.27,3.49a6.51,6.51,0,0,1-7.8-1.12l1.08,1.93a6.51,6.51,0,0,0,8.85,2.52l6.27-3.5A6.51,6.51,0,0,0,361.12,252.84Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 347.03,
    y: 237.32,
    width: 28.94,
    height: 25.31,
    rx: 10.37,
    transform: "translate(-181.49 60) rotate(-29.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M352,247.54l11.54-6.43a7.88,7.88,0,0,1,10.7,3l4,7.1a7.85,7.85,0,0,0-.89-2.58l-4.66-8.36A7.88,7.88,0,0,0,362,237.26l-11.53,6.43a7.88,7.88,0,0,0-3.05,10.71l.71,1.26A7.87,7.87,0,0,1,352,247.54Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M376.47,247.11l-4.66-8.36a7.82,7.82,0,0,0-3-3l.12.2,4.66,8.37a7.86,7.86,0,0,1-3,10.7L359,261.43a7.84,7.84,0,0,1-7.71,0,7.86,7.86,0,0,0,10.58,2.84l11.54-6.43A7.85,7.85,0,0,0,376.47,247.11Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M419.94,254.26c-20.62,1.34-32.06-1.33-44.74,5.73-8.64,4.81-23.64-22.15-15-27,13.8-7.68,17.45-18.42,28.39-35Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M362.43,239.83c13.8-7.68,18.15-16.91,29.09-33.5l-1.32-3c-10.94,16.6-15.28,25.82-29.09,33.51-4,2.22-2,8.75,1.18,15.11C360.26,246.51,359.07,241.7,362.43,239.83Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M416.7,248.46c-19.94,1.18-31.2-1.27-43.66,5.67-4.7,2.61-11.28-4.18-14.91-11.68,2.23,9.19,11.14,20.84,17.07,17.54,12.68-7.06,24.12-4.39,44.74-5.73Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 404.26,
    cy: 226.14,
    rx: 10.35,
    ry: 32.19,
    transform: "translate(-164.48 77.8) rotate(-29.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M417.7,254.7C419.25,249,416,237,409,224.52,401.5,211,392.15,201.43,386.55,201c-1.55,5.7,1.73,17.72,8.67,30.18C402.75,244.69,412.1,254.27,417.7,254.7Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M415.91,219.65c-9.75-17.48-23.08-28.63-29.78-24.89s-4.23,20.93,5.51,38.42,23.08,28.63,29.78,24.89S425.65,237.14,415.91,219.65Zm4,34.61c-5,2.79-16.06-7.55-24.72-23.08S383.6,200.81,388.59,198s16.06,7.55,24.72,23.08S424.93,251.48,419.94,254.26Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M414.09,219c-8.65-15.53-19.72-25.87-24.71-23.08a4.9,4.9,0,0,0-2.17,3.48,3.91,3.91,0,0,1,1.38-1.39c5-2.78,16.06,7.55,24.72,23.08,6.74,12.11,10,23.79,8.79,29.68C425,246,421.78,232.79,414.09,219Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M422.21,256c-6.71,3.73-20-7.42-29.78-24.9-7.44-13.34-10.63-26.52-8.75-33.67-3.31,6.41-.28,21,8,35.77,9.75,17.48,23.08,28.63,29.78,24.89a7.18,7.18,0,0,0,3.24-4.74A6.19,6.19,0,0,1,422.21,256Z",
    transform: "translate(-105.53 -147.61)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M395.22,231.18a94.32,94.32,0,0,0,5.94,9.36l8.75-4.87-10.77-19.34-8.76,4.88A97.3,97.3,0,0,0,395.22,231.18Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M392.75,226.44s-1.66-3.52-2.37-5.23l8.76-4.88,2.92,5.24Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M406.06,230.39l-8.52,4.74c1.19,1.91,2.4,3.72,3.62,5.41l8.75-4.87Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M407.63,224.27c3,5.34,4,10.44,2.28,11.4s-5.52-2.6-8.49-7.94-4-10.44-2.28-11.4S404.66,218.93,407.63,224.27Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M384.4,285c2.7-.7,5.48,4.31,2,6.39a24.19,24.19,0,0,1-8.47,3.14c-2.72.39-3.91-3.26-1.19-5.39A21.84,21.84,0,0,1,384.4,285Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M378,294.47a23.88,23.88,0,0,0,8.47-3.13,3.12,3.12,0,0,0,1.53-3.5,3.56,3.56,0,0,1-.64.48,23.76,23.76,0,0,1-8.47,3.14,2.27,2.27,0,0,1-2.65-1.84C374.24,291.77,375.45,294.84,378,294.47Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M382.74,278.48c3.19-.82,6.47,5.08,2.38,7.54a28.17,28.17,0,0,1-10,3.71c-3.21.47-4.62-3.85-1.4-6.36A25.71,25.71,0,0,1,382.74,278.48Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M375.12,289.73a28.26,28.26,0,0,0,10-3.71,3.74,3.74,0,0,0,1.75-4.37,3.77,3.77,0,0,1-1.75,2.15,28.26,28.26,0,0,1-10,3.71,2.67,2.67,0,0,1-3.05-1.86C371.39,287.85,372.77,290.08,375.12,289.73Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M378.11,271c3.39-1.79,8.71,4,4.74,7.91a33.22,33.22,0,0,1-10.34,6.9c-3.51,1.4-6.27-3.12-3.31-6.83A30,30,0,0,1,378.11,271Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M372.51,285.79a33.13,33.13,0,0,0,10.34-6.91,4.3,4.3,0,0,0,1.14-4.67,4.9,4.9,0,0,1-1.14,1.69,33,33,0,0,1-10.34,6.9,3.2,3.2,0,0,1-4.32-2C367.14,284,369.56,287,372.51,285.79Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M372.59,265.17c3.15-1.66,8.09,3.73,4.4,7.34a40.2,40.2,0,0,1-8.83,6.78c-3.43,1.75-6.51-2.19-3.76-5.64S369.9,266.58,372.59,265.17Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M368.16,279.29a40.2,40.2,0,0,0,8.83-6.78,4.08,4.08,0,0,0,.47-5.48,4,4,0,0,1-1.3,2.82,40,40,0,0,1-8.83,6.78,3.17,3.17,0,0,1-4-.59A3.21,3.21,0,0,0,368.16,279.29Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M368.92,261.48c3.23,0,5.81,6.39-4.48,11.3.2,2.72-1.74,4.51.19,6.84,2.93,3.55,4.46,5.55,3.84,9.36s-5.44,6.42-10.13,4-11.53-14.51.64-25.32c1.12-1,6.53-3.73,7-4.23C367.56,261.78,368,261.47,368.92,261.48Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M358.35,293c4.68,2.45,9.48-.05,10.12-4s-.91-5.81-3.85-9.36c-1.92-2.33,0-4.11-.18-6.84,10.28-4.91,7.72-11.29,4.48-11.31h-.21c1.38,2.14.65,6.44-6.76,10,.2,2.73-1.74,4.52.18,6.85,2.93,3.55,4.46,5.55,3.84,9.36C365.4,291.21,363.92,292.87,358.35,293Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 243.19,
    y: 152.01,
    width: 23.56,
    height: 35.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 240.76,
    y: 156.32,
    width: 28.41,
    height: 30.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M374.7,334.75H352.17a83.21,83.21,0,0,0,12.74-30.82h9.79Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M412.25,201.81a2.26,2.26,0,0,1-1.26-.38,2.34,2.34,0,0,1-.71-3.23L431,166a2.34,2.34,0,0,1,3.93,2.53l-20.73,32.24A2.33,2.33,0,0,1,412.25,201.81ZM426.72,216,461,198.88a2.34,2.34,0,1,0-2.09-4.18l-34.28,17.16a2.33,2.33,0,0,0-1,3.13,2.29,2.29,0,0,0,.9,1A2.34,2.34,0,0,0,426.72,216Zm4.89,21.07,38.3-1.52a2.34,2.34,0,0,0-.19-4.67l-38.3,1.52a2.34,2.34,0,0,0-1.82,3.68A2.31,2.31,0,0,0,431.61,237.11Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M248.67,217.44a1.42,1.42,0,1,1-1.42-1.42A1.42,1.42,0,0,1,248.67,217.44Zm3.21-1.42a1.42,1.42,0,1,0,1.41,1.42A1.41,1.41,0,0,0,251.88,216Zm4.62,0a1.42,1.42,0,1,0,1.42,1.42A1.42,1.42,0,0,0,256.5,216Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 83.75,
    y: 168.26,
    width: 78.41,
    height: 53.81,
    rx: 11.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 79.51,
    y: 168.26,
    width: 78.41,
    height: 53.81,
    rx: 11.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M213,354V331.55a2.32,2.32,0,0,1,3.57-2l17.75,11.22a2.33,2.33,0,0,1,0,3.93L216.61,356A2.33,2.33,0,0,1,213,354Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M204,246.85h22.79a3.24,3.24,0,0,1,3.24,3.24v15.48a3.25,3.25,0,0,1-3.24,3.25h-1.66l3.58,3.64-9.33-3.64H204a3.26,3.26,0,0,1-3.25-3.25V250.09A3.25,3.25,0,0,1,204,246.85Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 198.56,
    y: 245.13,
    width: 29.28,
    height: 21.97,
    rx: 3.79,
    transform: "translate(320.87 364.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "116.33 118.4 120.99 123.14 108.85 118.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M224.66,252.51H201.74a.86.86,0,1,1,0-1.71h22.92a.86.86,0,0,1,0,1.71Zm.85,3.61a.86.86,0,0,0-.85-.86H201.74a.86.86,0,1,0,0,1.71h22.92A.85.85,0,0,0,225.51,256.12Zm0,4.46a.85.85,0,0,0-.85-.85H201.74a.86.86,0,1,0,0,1.71h22.92A.85.85,0,0,0,225.51,260.58Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M540.15,180.17H517.36a3.25,3.25,0,0,0-3.25,3.24v15.48a3.25,3.25,0,0,0,3.25,3.25H519l-3.57,3.64,9.33-3.64h15.38a3.24,3.24,0,0,0,3.24-3.25V183.41A3.24,3.24,0,0,0,540.15,180.17Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 406.06,
    y: 30.85,
    width: 29.28,
    height: 21.97,
    rx: 3.79
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-50",
    points: "412.04 51.72 407.38 56.46 419.53 51.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M513.91,185a.85.85,0,0,1,.86-.86h22.92a.86.86,0,0,1,0,1.71H514.77A.85.85,0,0,1,513.91,185Zm.86,5.32h22.92a.86.86,0,0,0,.85-.86.85.85,0,0,0-.85-.85H514.77a.86.86,0,1,0,0,1.71Zm0,4.46h22.92a.86.86,0,0,0,0-1.71H514.77a.86.86,0,1,0,0,1.71Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M563.47,264.78V261.6h-1.35a4.3,4.3,0,0,0-.29-.7l1-1-2.26-2.25-.95,1a3.56,3.56,0,0,0-.7-.29V257H555.7v1.35a3.33,3.33,0,0,0-.7.29l-1-1-2.25,2.25,1,1a5.42,5.42,0,0,0-.29.7H551.1v3.18h1.35a5.42,5.42,0,0,0,.29.7l-1,1,2.25,2.25,1-1a4,4,0,0,0,.7.3v1.34h3.18V268a4.34,4.34,0,0,0,.7-.3l.95,1,2.26-2.25-1-1a4.3,4.3,0,0,0,.29-.7Zm-6.18,1.62a3.21,3.21,0,1,1,3.21-3.21A3.21,3.21,0,0,1,557.29,266.4Zm10.37,11.8v-1.68H567a3.92,3.92,0,0,0-.16-.36l.5-.5-1.18-1.19-.5.5a2.39,2.39,0,0,0-.37-.15v-.71h-1.67v.71a2.39,2.39,0,0,0-.37.15l-.5-.5-1.18,1.19.5.5a2.28,2.28,0,0,0-.15.36h-.71v1.68h.71a2.75,2.75,0,0,0,.15.36l-.5.5,1.18,1.19.5-.51a2.43,2.43,0,0,0,.37.16v.71h1.67v-.71a2.43,2.43,0,0,0,.37-.16l.5.51,1.18-1.19-.5-.5c.06-.12.11-.24.16-.36Zm-3.24.84a1.69,1.69,0,1,1,1.68-1.68A1.69,1.69,0,0,1,564.42,279Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M171.6,290.24l-1.72-2.61-1.1.73a4.83,4.83,0,0,0-.62-.42l.27-1.3-3.07-.63-.26,1.3a4.82,4.82,0,0,0-.74.14l-.72-1.11L161,288.06l.73,1.11a6.58,6.58,0,0,0-.42.61l-1.3-.27-.63,3.07,1.3.27a6.26,6.26,0,0,0,.14.73l-1.11.73,1.72,2.61,1.11-.73a4.22,4.22,0,0,0,.62.42l-.27,1.3,3.06.63.27-1.3a4.48,4.48,0,0,0,.73-.14l.73,1.11,2.61-1.72-.72-1.11a5,5,0,0,0,.41-.61l1.3.26.63-3.06-1.3-.27a4.66,4.66,0,0,0-.13-.73Zm-4.2,4.67a3.15,3.15,0,1,1,.9-4.37A3.16,3.16,0,0,1,167.4,294.91Zm-11.78-.35-1.08-1.65-.7.46a3.19,3.19,0,0,0-.38-.26l.16-.82-1.92-.4-.17.82a3.4,3.4,0,0,0-.46.09l-.46-.7L149,293.18l.46.7a2.7,2.7,0,0,0-.27.39l-.81-.17L148,296l.82.16a2.33,2.33,0,0,0,.08.46l-.69.46,1.08,1.65.7-.46a3.19,3.19,0,0,0,.38.26l-.17.82,1.93.39.17-.81a3.73,3.73,0,0,0,.46-.09l.46.7,1.64-1.09-.46-.69a2,2,0,0,0,.26-.39l.82.17.4-1.93-.82-.17a4,4,0,0,0-.08-.46ZM153,297.49a2,2,0,1,1,.57-2.75A2,2,0,0,1,153,297.49Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M333.3,181.27,331,177.71l-1.5,1a7.66,7.66,0,0,0-.84-.56l.36-1.77-4.16-.86-.36,1.77a6.78,6.78,0,0,0-1,.19l-1-1.51-3.55,2.34,1,1.5a6.46,6.46,0,0,0-.56.84l-1.77-.36-.86,4.16,1.77.37a6.91,6.91,0,0,0,.19,1l-1.51,1,2.34,3.55,1.5-1a6.46,6.46,0,0,0,.84.56l-.36,1.77,4.16.86.36-1.77a6.76,6.76,0,0,0,1-.18l1,1.5,3.55-2.34-1-1.5a6.46,6.46,0,0,0,.56-.84l1.77.37.86-4.17-1.77-.36a6.65,6.65,0,0,0-.19-1Zm-5.71,6.34a4.29,4.29,0,1,1,1.22-5.94A4.28,4.28,0,0,1,327.59,187.61Zm-16-.48-1.47-2.24-.95.63a3.8,3.8,0,0,0-.53-.36l.23-1.11-2.61-.54-.23,1.11a3.5,3.5,0,0,0-.63.12l-.62-1-2.23,1.47.62,1a6,6,0,0,0-.36.52l-1.11-.22-.54,2.61,1.11.23q0,.32.12.63l-.94.62,1.47,2.23.94-.62a3.74,3.74,0,0,0,.53.35l-.23,1.11,2.62.55.23-1.12a4.48,4.48,0,0,0,.62-.11l.62.94,2.24-1.47-.63-.94a4.5,4.5,0,0,0,.36-.53l1.11.23.54-2.62-1.11-.23a4.52,4.52,0,0,0-.12-.62Zm-3.59,4a2.69,2.69,0,1,1,.77-3.73A2.68,2.68,0,0,1,308,191.11Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-50",
    cx: 237.85,
    cy: 185.79,
    r: 9.98,
    transform: "translate(-158.32 -43.17) rotate(-22.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M237.16,194.17v-2.06a6,6,0,0,1-3.13-.9l.49-1.37a5.47,5.47,0,0,0,2.94.88c1.45,0,2.43-.84,2.43-2s-.79-1.82-2.31-2.43c-2.08-.82-3.36-1.75-3.36-3.53a3.35,3.35,0,0,1,3.08-3.29v-2.06h1.26v2a5.4,5.4,0,0,1,2.66.72l-.51,1.34a5,5,0,0,0-2.57-.69c-1.58,0-2.17.94-2.17,1.75,0,1.07.76,1.6,2.53,2.33,2.11.86,3.17,1.92,3.17,3.74a3.56,3.56,0,0,1-3.23,3.47v2.12Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-50",
    cx: 389.03,
    cy: 173.38,
    r: 10.96,
    transform: "translate(50.25 382.14) rotate(-80.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M388.27,182.58v-2.27a6.53,6.53,0,0,1-3.43-1l.54-1.5a6,6,0,0,0,3.23,1c1.59,0,2.66-.92,2.66-2.2s-.87-2-2.53-2.66c-2.29-.9-3.7-1.93-3.7-3.88a3.68,3.68,0,0,1,3.39-3.61v-2.26h1.38v2.17a6.05,6.05,0,0,1,2.92.79l-.56,1.48a5.4,5.4,0,0,0-2.83-.77c-1.72,0-2.37,1-2.37,1.93,0,1.17.83,1.75,2.78,2.56,2.31.94,3.47,2.1,3.47,4.1a3.9,3.9,0,0,1-3.54,3.81v2.33Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-50",
    cx: 547.99,
    cy: 218.44,
    r: 8.04,
    transform: "translate(139.27 576.88) rotate(-80.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M547.43,225.19v-1.66a4.75,4.75,0,0,1-2.52-.72l.4-1.1a4.4,4.4,0,0,0,2.37.7c1.16,0,2-.67,2-1.61s-.64-1.46-1.86-2c-1.67-.65-2.71-1.41-2.71-2.84a2.7,2.7,0,0,1,2.48-2.65v-1.66h1v1.6a4.33,4.33,0,0,1,2.14.57l-.41,1.09a3.93,3.93,0,0,0-2.07-.56c-1.27,0-1.75.75-1.75,1.41,0,.86.61,1.29,2,1.88,1.7.69,2.55,1.54,2.55,3a2.85,2.85,0,0,1-2.59,2.79v1.71Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M174.09,328a6.1,6.1,0,1,1-6.1-6.1A6.11,6.11,0,0,1,174.09,328Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M167.56,333.15v-1.26a3.68,3.68,0,0,1-1.9-.55l.29-.84a3.33,3.33,0,0,0,1.8.54c.89,0,1.48-.51,1.48-1.22s-.48-1.11-1.41-1.49c-1.27-.5-2-1.07-2-2.15a2,2,0,0,1,1.88-2v-1.26h.77v1.21a3.29,3.29,0,0,1,1.62.43l-.31.83a3,3,0,0,0-1.57-.43c-1,0-1.32.58-1.32,1.08s.46,1,1.55,1.42c1.28.52,1.93,1.17,1.93,2.28a2.17,2.17,0,0,1-2,2.12v1.3Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-50",
    cx: 178.92,
    cy: 237.12,
    r: 8.61,
    transform: "translate(-182.32 -61.64) rotate(-22.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M178.92,230.58a17.71,17.71,0,0,1,.54,3.27,32.5,32.5,0,0,1,.13,3.27l-.67-.67c1,0,1.93.06,2.89.16a17.06,17.06,0,0,1,2.88.51,18.1,18.1,0,0,1-2.88.5c-1,.11-1.92.14-2.89.16h-.65v-.67q0-1.63.12-3.27A19.57,19.57,0,0,1,178.92,230.58Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M493.08,182.23a10,10,0,1,1-10-10A10,10,0,0,1,493.08,182.23Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M488.91,181.94a4.94,4.94,0,1,0-7.34,1.36l-2.82,4.85a.73.73,0,0,0,.26,1,.72.72,0,0,0,1-.27l2.82-4.84A4.93,4.93,0,0,0,488.91,181.94Zm-6,.54a3.5,3.5,0,1,1,4.78-1.27A3.5,3.5,0,0,1,482.88,182.48Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M551.86,321.35a6.17,6.17,0,1,1-6.17-6.17A6.16,6.16,0,0,1,551.86,321.35Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M547.92,321.56a2.87,2.87,0,0,0-2.59-4.65,2.85,2.85,0,0,0-2.46,2.34,2.79,2.79,0,0,0,.6,2.3,3.35,3.35,0,0,1,.8,2.07V324h-.07v1.38h3V324h-.07v-.34A3.23,3.23,0,0,1,547.92,321.56Zm-4-.38a2.27,2.27,0,0,1-.48-1.83,2.3,2.3,0,0,1,2-1.85,2.24,2.24,0,0,1,1.79.55,2.27,2.27,0,0,1,.77,1.71,2.23,2.23,0,0,1-.51,1.42,3.82,3.82,0,0,0-.94,2.44v.13h-.3a5.35,5.35,0,0,0,.35-2.56.34.34,0,0,0-.2-.17.43.43,0,0,0-.31.05.53.53,0,0,0-.4-.21h0a.42.42,0,0,0-.37.22l0,0a.37.37,0,0,0-.4.06c-.3.25,0,1.63.32,2.64h-.29v-.13A3.9,3.9,0,0,0,543.93,321.18Zm1.54,2.57a6.65,6.65,0,0,1-.43-2.43s0,0,.09,0a.1.1,0,0,1,0,0,.43.43,0,0,0,.07.4.26.26,0,0,0,.27,0,.21.21,0,0,0,.12-.21.58.58,0,0,0-.12-.3l0-.06s.06-.07.09-.07a.26.26,0,0,1,.18.11.54.54,0,0,0-.14.22.24.24,0,0,0,.16.34.25.25,0,0,0,.25-.05.48.48,0,0,0,.07-.43l.11,0,0,0a5.63,5.63,0,0,1-.4,2.43Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 155.16,
    y: 183.79,
    width: 55.28,
    height: 38.28,
    rx: 2.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 152.04,
    y: 183.79,
    width: 55.28,
    height: 38.28,
    rx: 2.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M260.27,367.19l24.54-25.58a.61.61,0,0,1,.88,0l23.85,25Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M260.27,367.19l23.58-21.67a2,2,0,0,1,2.72,0l23.57,21.67a1.43,1.43,0,0,1-1,2.49H261.24A1.44,1.44,0,0,1,260.27,367.19Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M283,353.65,259.74,333.3a1.08,1.08,0,0,1,.71-1.9H310a1.09,1.09,0,0,1,.72,1.9l-23.3,20.35A3.3,3.3,0,0,1,283,353.65Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M283.75,356.21l-24-22.91h50.94l-24,22.91A2.22,2.22,0,0,1,283.75,356.21Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M545.43,374.77H175.91a2.56,2.56,0,0,1-2.56-2.56h0a2.56,2.56,0,0,1,2.56-2.56H545.43a2.56,2.56,0,0,1,2.56,2.56h0A2.56,2.56,0,0,1,545.43,374.77Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "433.94 132.46 435.84 134.59 442.92 135.68 433.42 138.25 430.82 133.76 433.94 132.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M492.18,244.22c-2.89,8.26,0,10.54,5.05,12.22,2,.67,18.65-.9,23.62.68s15.5,26.07,15.5,26.07l4.57-2.74s-10.4-28.66-11.91-29.71c-2.34-1.63-16.08-3-20-4s-7.07-5.1-7.07-5.1Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M493.55,225.34S494.67,237,496,239.4s17.15,7.74,18.54,7.84a9.89,9.89,0,0,0,3.64-1s3.49,1.25,4.06.95-3.12-2.95-4.54-3.22-3.57.83-3.57.83-12.22-5.08-13.58-7.27-2.4-13-2.4-13Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "391.02 66.36 389.52 70.34 393.31 71.17 393.97 66.67 391.02 66.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M495,211a1.89,1.89,0,0,1,.1.41,6.49,6.49,0,0,0,1,2.87,3.79,3.79,0,0,0,2.72,1.67,3.71,3.71,0,0,0,2.71-1,6.39,6.39,0,0,0,1.57-2.51c.54-1.47,1.15-3.29.3-4.6-.41-.63-2.56-1.67-4.09-2.36a2.33,2.33,0,0,0-2.7.58l-1.5,1.68a2.36,2.36,0,0,0-.47,2.29Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M497.17,206.92a1.05,1.05,0,0,0-1.14.63,1.7,1.7,0,0,0,.08,1.36,5.31,5.31,0,0,0,.82,1.14c-.58.85-1.58,1.91-1.46,2.94-.79-.51-.74-1.15-1.37-1.86-1.15-1.31-3-6.62,1.18-8.16,4.45-5.81,10.81,3.07,11.81,2.61a3.8,3.8,0,0,1-3.55,3.36,4.92,4.92,0,0,1-3.07-.55,7.82,7.82,0,0,0-1.4-.74c-.37-.13-.75,1.46-1.06,1.33S497.54,207,497.17,206.92Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "432.44 133.8 434.34 135.92 441.42 137.02 431.92 139.59 429.32 135.09 432.44 133.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M492.56,242.85c-2.89,8.25-1.87,13.25,3.17,14.93,2,.66,25.5.85,25.5.85l13.62,25.89,4.57-2.74s-11.29-28.9-12.6-30-15-3-18.89-4.05-5.63-7.54-5.63-7.54Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M499.25,218.27c-3.77-3.22-8.34-1-9.16,9a220.45,220.45,0,0,0-.2,23c6.49,1.52,13.24-.68,18.93-3.25,0,0-5.29-6.64-6.43-13.14C501.47,228.57,502.3,220.86,499.25,218.27Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M496.3,226.15a2.33,2.33,0,0,0-1.9,2.56c.39,3.49,1.25,10.13,2.23,11.89,1.35,2.42,14,7.21,15.4,7.3a7.67,7.67,0,0,0,2.88-.66,2.32,2.32,0,0,1,1.58-.05c1.07.35,2.85.88,3.25.67.57-.31-3.13-3-4.54-3.23a5.45,5.45,0,0,0-2.67.44,2.36,2.36,0,0,1-1.91-.11c-2.39-1.26-8.35-4.49-9.44-6.23-.95-1.52-1.74-7.21-2.13-10.55a2.35,2.35,0,0,0-2.75-2Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M495.48,218.74C490.76,220,493,229.9,493,229.9c2.18.78,4.88.47,7.85-.39C499.9,227.16,499.74,217.58,495.48,218.74Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M527.41,248.82H509a1.06,1.06,0,0,1,0-2.12H526.5L529,230.41a1.07,1.07,0,0,1,1.21-.89,1.06,1.06,0,0,1,.89,1.21l-2.62,17.19A1.06,1.06,0,0,1,527.41,248.82Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 349.39,
    y: 109.04,
    width: 72.48,
    height: 113.04,
    rx: 7.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 345.53,
    y: 109.04,
    width: 72.48,
    height: 113.04,
    rx: 7.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 345.53,
    y: 116.66,
    width: 72.48,
    height: 97.79
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M516.9,271.57H457.69a1.4,1.4,0,0,1-1.4-1.41h0a1.4,1.4,0,0,1,1.4-1.4H516.9a1.4,1.4,0,0,1,1.4,1.4h0A1.41,1.41,0,0,1,516.9,271.57Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M516.9,277.71H457.69a1.39,1.39,0,0,1-1.4-1.4h0a1.39,1.39,0,0,1,1.4-1.4H516.9a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,516.9,277.71Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M516.9,283.86H457.69a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.41H516.9a1.41,1.41,0,0,1,1.4,1.41h0A1.4,1.4,0,0,1,516.9,283.86Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M516.9,290H457.69a1.4,1.4,0,0,1-1.4-1.41h0a1.4,1.4,0,0,1,1.4-1.4H516.9a1.4,1.4,0,0,1,1.4,1.4h0A1.41,1.41,0,0,1,516.9,290Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 350.76,
    y: 145.53,
    width: 62.02,
    height: 47.25,
    rx: 4.57
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M514.91,356.8H459.67a3.38,3.38,0,0,1-3.38-3.39v-.56a3.38,3.38,0,0,1,3.38-3.39h55.24a3.39,3.39,0,0,1,3.39,3.39v.56A3.39,3.39,0,0,1,514.91,356.8Zm2-12.84H457.66a1.37,1.37,0,0,0-1.37,1.38h0a1.37,1.37,0,0,0,1.37,1.37h59.27a1.37,1.37,0,0,0,1.37-1.37h0A1.37,1.37,0,0,0,516.93,344Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M242.86,284.77a39.56,39.56,0,0,0,9.35-18.36l3-.61s-1.19,14.55-6,19.58S242.86,284.77,242.86,284.77Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M252.93,266.23a2.79,2.79,0,0,1-1-2.86c.46-1.79,1.63-2,1.44-1a2.44,2.44,0,0,0,.45,1.81,2.8,2.8,0,0,1,.2,1.84Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M243.58,278.73c.26.47-.53,4.08-.53,4.08l3.23-.88-.72-3.6Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M243.94,279a7.93,7.93,0,0,1-3.29-.86l-2.55-2-.25-4.53,5.2-3.58S250.55,278,243.94,279Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M239,273.53a9.37,9.37,0,0,0,5-9.54,8.38,8.38,0,0,1-3.24,2.05,12.36,12.36,0,0,0-3.41,1.8,3.6,3.6,0,0,0-1.37,3.42c-1.39.42-1.85,2.25-1.48,3.66a5.5,5.5,0,0,0,2.84,3.48c1.38.68,3.35.3,4.77-.3-1.35-.4-4-2-1.83-2.53A11.4,11.4,0,0,0,239,273.53Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M241,282.85a27.61,27.61,0,0,1,1.14-2.63l5.73-.43.33,1.61Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "143 216.65 143.1 219.18 148.98 222.04 139.66 221.94 140.84 216.08 143 216.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "124.27 216.65 124.17 219.18 118.29 222.04 127.61 221.94 126.43 216.08 124.27 216.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M241,312.53s0-.11,0-.15l-1.93.08-1.79-.08c0,.05,0,.1,0,.15l-8,.32V367l3.64-.28s3.85-24.7,6.25-40.87c2.4,16.17,6.25,40.87,6.25,40.87l3.64.29v-54.1Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M273,274.48s.52-2,1.58-2.11l-.32,1.18a7.43,7.43,0,0,0,2.05-1.77c.46-.82,1.77,2.24.47,3.43a3.86,3.86,0,0,1-2.33,1.19Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M227.11,320.11s7-33.56,14.12-37.85c2.78-1.66,10.86-.11,18.16-1.69,9.65-2.08,13.73-6.71,13.73-6.71l3,1.92s-5.89,8.16-24.52,13.39c-3.91,10.57-.51,30.94-.51,30.94S234.32,318.73,227.11,320.11Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M432.18,317.62c-1.23.28-8.57-1.79-11.69-4.37,0,0,4.06-15.08,3.95-18.8s1.89-11.53,4.56-5.68S432.18,317.62,432.18,317.62Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "326.43 216.12 326.59 218.65 321.01 222.07 330.56 222.07 329.16 215.39 326.43 216.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M438,311c.1,4.54-2.73,54.82-2.73,54.82l-3.6.64-5.16-54.93Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "321.58 216.12 321.74 218.65 316.16 222.07 325.64 221.75 324.3 215.39 321.58 216.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M433.18,311c.09,4.54-2.73,54.82-2.73,54.82l-3.6.64-3.52-55.35Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M434.87,314c-7.77.23-11.56-1.89-12-2.63s.17-1.25.43-2.25c1-4,3.61-14.22,3.52-17.19-.12-3.72,1.89-11.53,4.56-5.69S434.87,314,434.87,314Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "288.44 148.49 308.11 164.93 313.05 155.91 295.96 143.19 288.44 148.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "289.89 148.69 308.07 163.39 312.33 156.02 296.05 143.88 289.89 148.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "289.34 147.06 290.14 147.63 294.99 144.22 294.35 143.76 289.34 147.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M407.21,285.47l-.34,3.42s13,13.84,24.92.66l-.87-7.79S423.35,297.53,407.21,285.47Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M407.21,285.47c-1.64-.56-2.31-2.28-3.22-.41-1.67,3.42,2.88,3.83,2.88,3.83Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M406,278.64l-2.65,10,.06,1.36.84-1.05,2.59-10C406.94,278.18,406.3,277.92,406,278.64Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M405.78,286s-1.95.69-2.15.29,1.52-1.16,1.89-1.75,1.11,1,1.11,1Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "321.75 128.8 323.68 133.3 325.42 131.77 325.67 126.83 321.75 128.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M424.29,269.3c-.84,4.92-1.42,8.22,2.28,8.44,3.36.2,6.23-5,6.23-5C435.39,266.93,425.72,260.76,424.29,269.3Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M420.9,264.39c3.39,4.91,8.17,5.65,9.67,5.13.69-.24.71.52.44,2,1.88-.87,1.2,1.52-.16,2.39a10.5,10.5,0,0,0-.61,2.12s4.65-3,4.66-6.22c0-3.89-2.87-3.46-2.87-3.46s-1.71-5.25-6.42-3.6Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "321.93 132.01 326.54 129.43 327.85 131.78 321.13 135.53 321.93 132.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M405.58,303.52l.53,4.14c-.12.1,14.38,5.59,20.55-10.64a172.36,172.36,0,0,1-3.91,18.83,29.57,29.57,0,0,0,16.57,1.79s1.28-28.75-5.07-37.74c-3.37-4.76-8.1,3-9.27,7.82C423.49,293.79,420,307.37,405.58,303.52Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M405.58,303.52s-2.5-.68-3.44-.06.37,2.64,1.46,3.77a2.21,2.21,0,0,0,2.51.43Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M155.51,148.35c.79.37,10.28,7.54,10.28,7.54l29.54-4.43Z",
    transform: "translate(-105.53 -147.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "59.48 20.84 60.27 8.28 89.8 3.85 59.48 20.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "59.48 20.84 68 13.36 89.8 3.85 59.48 20.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "68 13.36 79.95 21.91 89.8 3.85 68 13.36"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesBanner);
export default __webpack_public_path__ + "static/media/sales-banner.7ad1bdaf06fc746b4ffaa00eeffa9707.svg";
export { ForwardRef as ReactComponent };